module.exports = __webpack_public_path__ + "static/maaaato-9538b6fad93b4cd0f4387b54763b48cf.jpg";